import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Panel extends OBase {
  update () {
    let valTree = this.getStringInput('Panel');
    let output = this.getGenericObjectOutput('Panel');

    let tree = new Geometry.DataTree();

    if (valTree.branches.length <= 0) {
      // console.log('Panel empty', this.inputs['Panel'], this.ghGeometryObject.instanceGuid)
    }
    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let vals = val.split('\n');
        for (let n = 0; n < vals.length; n++) {
          tree.add(vals[n], valTree.paths[i]);
        }
      }
    }

    output.value = tree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Panel.js